var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',[_c('div',{staticClass:"topimg"}),_c('div',{staticClass:"con"},[_c('List',{attrs:{"list":_vm.newslist,"type":"media"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }